import React from "react"
import Button from "@material-ui/core/Button"
import {red, green, blue, orange, pink, grey, lightGreen} from "@material-ui/core/colors"
import {makeStyles} from "@material-ui/core"
import {useStore} from "../Store"
import clsx from "clsx"

const useStyles = makeStyles(() => ({
  root: {
    color: `white`,
    minWidth: 128,
    display: `flex`,
    alignItems: `center`,
    justifyContent: `center`,
    backgroundColor: (props) => props.bgColor,
    "&:hover": {
      backgroundColor: (props) => props.bgColorHover,
    },
    marginTop: `16px`,
    zIndex: (props) => (props.zIndex === props.className ? 1201 : 0),
  },
}))

export default function BaseButton({color = null, className = null, label = null, ...buttonProps}) {
  let bgColorHover = null
  let bgColor = null
  if (color === `red`) (bgColorHover = red.A700), (bgColor = red.A400)
  if (color === `green`) (bgColorHover = green.A700), (bgColor = lightGreen.A700)
  if (color === `blue`) (bgColorHover = blue.A700), (bgColor = blue.A400)
  if (color === `orange`) (bgColorHover = orange.A700), (bgColor = orange.A400)
  if (color === `pink`) (bgColorHover = pink.A400), (bgColor = pink.A200)
  if (color === `grey`) (bgColorHover = grey[900]), (bgColor = grey[800])
  const {
    store: {zIndex},
  } = useStore()
  const classes = useStyles({
    bgColorHover,
    bgColor,
    className,
    zIndex,
  })
  return (
    <Button className={clsx(classes.root, className)} {...buttonProps}>
      {label}
    </Button>
  )
}
